function initFAQSection(scope) {
  scope.querySelectorAll("[data-faq]").forEach(item => {
    const trigger = item.querySelector("[data-faq-trigger]");
    const content = item.querySelector("[data-faq-content]");

    if (!trigger || !content) return;

    trigger.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      // Close all in this section only
      scope.querySelectorAll("[data-faq]").forEach(i => {
        const c = i.querySelector("[data-faq-content]");
        if (c) c.style.maxHeight = null;
        i.classList.remove("active");
      });

      // Open clicked
      if (!isOpen) {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
}

/* --------- FIRE ON PAGE LOAD --------- */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".faq-section").forEach(section => {
    initFAQSection(section);
  });
});

/* --------- FIRE WHEN SHOPIFY LOADS SECTION (customizer) --------- */
document.addEventListener("shopify:section:load", (e) => {
  if (e.target.matches(".faq-section")) {
    initFAQSection(e.target);
  }
});
